import { GET_MEMBER_OUTGOING_EVALUATIONS } from '../../../constants/api'
import errorHandler from '../errorHandler'
import { IEvaluationPure } from '../../../common/models/Evaluation'

export default (termNumber: number, token: string) =>
  fetch(GET_MEMBER_OUTGOING_EVALUATIONS(termNumber.toString()), {
    method: 'GET',
    headers: {
      Authorization: 'Bearer ' + token,
    },
  })
    .then(errorHandler)
    .then(
      async (termStatesResponse: Response): Promise<IEvaluationPure[]> => {
        const evaluations: IEvaluationPure[] = await termStatesResponse.json()
        return evaluations
      }
    )
